"use client";
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import houses from "../../assets2/images/houses.svg";
import bed from "../../assets2/images/bed.svg";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { useNavigate } from "react-router-dom";

import { BsThreeDotsVertical } from "react-icons/bs";
import axios from "axios";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import MovetoOtherFolderModal from "./MovetoOtherFolderModal";
import { RxCross2 } from "react-icons/rx";
import { base_URL } from "../../config/config";
import HotelCard from "../shared/card/hotel/HotelCard";
import { getS3Thumb } from "../../utils/utilityFunctions";
import SecureImg from "../shared/SecureImg";

const VenueStayFavoriteDetail = ({
	data,
	name,
	removeVenueStay,
	isCompareMode,
	onSelect,
	handleRemove,
	handleCompare,
	selectedVenues,
	clearSelectedVenues,
	setIsCompareMode,
	compareType,
	setCompareType,
	isBulkEnquiry,
	selectedEnquiries,
	setIsBulkEnquiry,
	handleBulkEnquiry,
	handleEnquiryRemove,
	onEnquirySelect,
	setEnquiryType,
	enquiryType,
}) => {
	const [isSelectedEnquiry, setIsSelectedEnquiry] = useState(false);
	const [isSelectedCompare, setIsSelectedCompare] = useState(false);
	const [isMobileView, setIsMobileView] = useState(false);
	const [options, setOptions] = useState(false);
	const user = useSelector((state) => state.auth.user);
	const navigate = useNavigate();
	const [moveToOther, setMoveToOther] = useState(false);
	const [itemId, setItemId] = useState(null);
	// console.log("Data inside Stay Detail Component", data);

	const handleViewPreviewDetails = () => {
		const cf = "dhpv"; // From the Favourite list only for Stay // Ankita Test
		const venueId = data?._id;
		const hotelName = data?.overview?.basicDetails?.hotelName;
		const slug = data?.overview?.basicDetails?.hotelName
			?.toLowerCase()
			?.replace(/[^a-z0-9]+/g, "-") // replace spaces/specials with hyphens
			?.replace(/(^-|-$)/g, ""); // trim leading/trailing hyphens
		navigate(`/hotel-preview/${cf}/${venueId}/${slug}`, {
			state: {
				breadcrumbPath: [
					{ name: "Home", to: "/" },
					{ name: "My Favorites", to: "/my-favorites" },
					{ name: name, to: `/favorite-detail/${user?._id}/${name}` },
					{ name: hotelName, to: "" },
				],
			},
		});
	};
	if (isMobileView) {
		// console.log("");
	}
	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth < 1024); // lg breakpoint in Tailwind
		};

		window.addEventListener("resize", handleResize);

		handleResize(); // Set initial value

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);
	const handleDelete = async () => {
		try {
			await fetch(`${base_URL}/api/auth/delete-folder`, {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					customerId: user?._id,
					folderName: name,
				}),
			});
		} catch (error) {
			console.log(error);
		}
	};
	const removeHandle = async (itemId) => {
		// console.log("itemId", itemId);
		try {
			const response = await axios.put(`${base_URL}/api/auth/unfav-item`, {
				customerId: user?._id,
				itemId,
				type: "venuesAndStay",
				folderName: name,
			});
			const data = await response.data;
			if (
				data.folder.venues.length === 0 &&
				data.folder.venuesAndStay.length === 0
			) {
				await handleDelete();
			}
			// console.log("response", response);
			toast.success("Successfully removed from favorites");
			navigate("/my-favorites");
		} catch (error) {
			console.log(error);
		}
	};

	const moveHandle = (id) => {
		// console.log("clicked");
		setItemId(id);
		setMoveToOther(true);
	};

	const ellipsisOverlay = () => {
		return (
			<>
				<div
					className="bg-white absolute top-3 right-5 p-1.5 rounded-full cursor-pointer"
					onClick={(e) => {
						e.stopPropagation();
						setOptions(!options);
					}}
				>
					<BsThreeDotsVertical size={20} />
				</div>
				{options && (
					<div className="bg-white absolute top-12 right-8 rounded-md w-40 z-0 flex flex-col justify-center items-center">
						<div
							className="text-[14px] cursor-pointer py-3 px-3"
							onClick={(e) => {
								e.stopPropagation();
								removeHandle(data?._id);
							}}
						>
							Unfavorite
						</div>
						<div
							className="text-[14px] cursor-pointer py-3 px-3"
							onClick={(e) => {
								e.stopPropagation();
								moveHandle(data?._id);
							}}
						>
							Move to other list
						</div>
					</div>
				)}
			</>
		);
	};

	return (
		<>
			{moveToOther && (
				<MovetoOtherFolderModal
					isOpen={moveToOther}
					onClose={() => setMoveToOther(false)}
					data={user.favoritesFolder}
					type={"venuesAndStay"}
					itemId={itemId}
					preName={name}
				/>
			)}
			<HotelCard
				onClick={() => handleViewPreviewDetails()}
				className={`${isCompareMode ? "mb-0 " : "mb-20"} ${
					isBulkEnquiry ? "mb-0 " : "mb-20"
				}`}
			>
				{selectedVenues?.length > 0 &&
					isCompareMode &&
					compareType === "venuesAndStays" && (
						<div className="fixed bottom-0 left-0 right-0 bg-white shadow-md z-50 p-4 px-6 flex items-center overflow-x-auto custom-scrollbar1 justify-between gap-4">
							<div className="flex items-center gap-5 overflow-x-auto custom-scrollbar1 px-2 md:px-0">
								<span className="text-dark md:text-[16px] text-[11px]">
									Compare Venues (Up to 3 Venues)
								</span>
								{selectedVenues?.map((venue) => (
									<div
										key={venue?._id}
										className="flex items-center bg-gray-100 shadow-md rounded p-2 md:min-w-60 gap-y-2 gap-x-7 ml-2"
									>
										<SecureImg
											src={getS3Thumb(venue?.photoVideo?.images[0])} fallbackSrc={venue?.photoVideo?.images[0]}
											alt={venue?.name}
											className="md:h-10 md:w-10 h-6 w-6 object-cover rounded"
										/>
										<span className="md:text-sm font-medium text-xs ">
											{" "}
											{venue?.overview?.basicDetails?.hotelName || "Undefined"}
										</span>
										<button
											onClick={(e) => {
												e.stopPropagation();
												handleRemove(venue?._id);
											}}
											className=" text-lg font-bold focus:outline-none"
										>
											<RxCross2
												size={22}
												className="text-primary cursor-pointer"
											/>
										</button>
									</div>
								))}
							</div>
							<div>
								<div className="flex justify-center items-center gap-4">
									<button
										onClick={(e) => {
											e.stopPropagation();
											handleCompare(e);
										}}
										className="bg-[#FE4747] md:w-auto w-full text-[12px] rounded-lg text-white py-2 md:px-4 px-3 lg:text-[16px] lg:font-[500]"
									>
										Compare
									</button>
									<div>
										<RxCross2
											size={22}
											className="text-primary cursor-pointer"
											onClick={(e) => {
												e.stopPropagation();
												setIsSelectedCompare(false);
												clearSelectedVenues();
												setIsCompareMode(false);
												setCompareType("both");
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				{selectedEnquiries?.length > 0 &&
					isBulkEnquiry &&
					enquiryType === "venuesAndStays" && (
						<div className="fixed bottom-0 left-0 right-0 bg-white shadow-md z-50 p-4 px-6 flex items-center justify-between gap-4">
							<div className="flex items-center gap-5 overflow-x-auto custom-scrollbar1 px-2 md:px-0">
								<span className="text-dark md:text-[16px] text-[11px]">
									Venue & Stays
								</span>
								{selectedEnquiries?.map((venue) => (
									<div
										key={venue._id}
										className="flex items-center bg-gray-100 shadow-md rounded p-2 md:min-w-60 gap-y-2 gap-x-7 ml-2"
									>
										<SecureImg
											src={getS3Thumb(venue?.photoVideo?.images[0])} fallbackSrc={venue?.photoVideo?.images[0]}
											alt={venue?.name}
											className="md:h-10 md:w-10 h-6 w-6 object-cover rounded"
										/>
										<span className="md:text-sm font-medium text-xs ">
											{" "}
											{venue?.overview?.basicDetails?.hotelName || "Undefined"}
										</span>
										<button
											onClick={(e) => {
												e.stopPropagation();
												handleEnquiryRemove(venue._id);
											}}
											className=" text-lg font-bold focus:outline-none"
										>
											<RxCross2
												size={22}
												className="text-primary cursor-pointer"
											/>
										</button>
									</div>
								))}
							</div>
							<div>
								<div className="flex justify-center items-center gap-4">
									<button
										onClick={(e) => {
											e.stopPropagation();
											handleBulkEnquiry(e);
										}}
										className="bg-[#FE4747] md:w-auto w-full text-[12px] rounded-lg text-white py-2 md:px-4 px-3 lg:text-[16px] lg:font-[500]"
									>
										Send Enquiry
									</button>
									<div>
										<RxCross2
											size={22}
											className="text-primary cursor-pointer"
											onClick={(e) => {
												e.stopPropagation();
												setIsBulkEnquiry(false);
												setEnquiryType("");
												setIsSelectedEnquiry(false);
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				<HotelCard.Slider images={data?.photoVideo?.images}>
					{ellipsisOverlay()}
				</HotelCard.Slider>
				<HotelCard.Details>
					<HotelCard.HotelName
						name={data?.overview?.basicDetails?.hotelName || "Undefined"}
						rating={data?.overview?.basicDetails?.hotelRating}
					/>
					<HotelCard.Location>
						{data?.overview?.locationDetails?.city ||
						data?.overview?.locationDetails?.area ? (
							<>
								{data?.overview?.locationDetails?.city},{" "}
								{data?.overview?.locationDetails?.area}
							</>
						) : (
							""
						)}
					</HotelCard.Location>
					<HotelCard.Icons
						room={data?.accommodation?.accommodations}
						venu={data?.additionalDetails?.venueSetting?.[0]}
					/>
					<HotelCard.Pricing price={data?.pricing?.basePrice} />
					<p className="text-secondary font-outfit font-normal text-[14px] leading-[156%] tracking-[0.01em] whitespace-nowrap overflow-hidden text-ellipsis">
						Starting price per room per night
					</p>
					{(compareType === "both" || compareType === "venuesAndStays") &&
						isCompareMode && (
							<div className="flex justify-between my-2 w-full items-center gap-2 ">
								<input
									type="checkbox"
									checked={
										selectedVenues?.find((venue) => venue._id === data._id) ||
										false
									}
									onChange={() => {
										const isSelected = selectedVenues?.find(
											(venue) => venue._id === data._id
										);

										if (!isSelected && selectedVenues.length >= 3) {
											toast.error("Maximum 3 venues can be selected");
											return;
										}
										setIsSelectedCompare(!isSelectedCompare);
										onSelect(data);
										setCompareType("venuesAndStays");
										// console.log(compareType);
									}}
									onClick={(e) => e.stopPropagation()}
									className=" h-5 w-6"
								/>
								<span className="text-[16px] text-dark">Compare</span>
							</div>
						)}
					{(enquiryType === "both" || enquiryType === "venuesAndStays") &&
						isBulkEnquiry && (
							<div className="flex justify-between my-2 w-full items-center gap-2 ">
								<input
									type="checkbox"
									checked={selectedEnquiries?.find(
										(venue) => venue._id === data._id
									)}
									onChange={() => {
										setIsSelectedEnquiry(!isSelectedEnquiry);
										onEnquirySelect(data);
										setEnquiryType("venuesAndStays");
									}}
									className=" h-5 w-6"
									onClick={(e) => e.stopPropagation()}
								/>
								<span className="text-[16px] text-dark">Bulk Enquiry</span>
							</div>
						)}
				</HotelCard.Details>
			</HotelCard>
		</>
	);
};

export default VenueStayFavoriteDetail;
